import localForage from 'localforage';

// Initialize a storage bucket for scheduler data
export default localForage.createInstance({
  name: 'scheduler'
});
